import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from 'store'
import { useLocation } from 'react-router-dom'
import { Toolbar, Item } from 'devextreme-react/toolbar'

import { useIxAuth } from 'contexts/auth-context'

import { IxWelcomeModal } from 'components/welcome-modal/welcome-modal'

import { IxLangToggle, ThemeSwitcher } from 'components'
import { toggleDrawer } from 'slices/ui'

import { titles as titles_map } from 'routes'

import { UserSection } from 'layout/user-section/user-section'

import './nav-bar.scss'

export const NavBar = () => {
    const { user } = useIxAuth()
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    const location = useLocation()
    const pathName = location.pathname
    const [titlePage, setTitlePage] = useState('');
    const [popupVisible, setPopupVisible] = useState(false)

    useEffect(() => {
        const title = titles_map[pathName]
        if (title !== undefined) {
            setTitlePage(title)
        }
    }, [pathName])

    const onDrawerToggleClick = () => { dispatch(toggleDrawer(null)) }

    return (
        <div>
            <UserSection popupVisible={popupVisible} setPopupVisible={setPopupVisible}/>
            <Toolbar className='navbar'>
                <Item widget='dxButton' location='before' cssClass='menu-btn' options={{type: 'default', icon: 'menu', onClick: onDrawerToggleClick}} />
                <Item location='before' text={t(titlePage)}/>
                <Item component={ThemeSwitcher} location='after' />
                <Item component={IxLangToggle} location='after' />
                <Item component={IxWelcomeModal} location='after' />
                <Item location='after'>
                    <img src='/images/V-pink.svg' alt='avatar' height={37} width={45} onClick={() => {setPopupVisible(true)}}/>
                </Item>
                <Item text={user ? user.firstName : 'No user'} location='after' />
            </Toolbar>
        </div>
    )
}
